import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import SvgStar from '../generated/svg/star'
import { AutoImage } from './auto-image'
import { DecoratedFrame } from './decorated-frame'

const Outer = styled.div`
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  @media (max-width: 40rem){
    margin-top: 0;
  }
`

const Item = styled.div`
  display: flex;
  gap: 2rem;
  @media (max-width: 40rem){
    flex-direction: column;
  }
`

const ImageContainer = styled.div`
  flex: 0 0 30rem;
  @media (max-width: 40rem){
    order: -1;
    flex: 0 0 auto;
  }
`

const TextContainer = styled.div`
  font-weight: 700;
`

const Title = styled.div`
  font-size: 2rem;
  @media (max-width: 40rem){
    font-size: 1.5rem;
  }
  svg {
    height: 1em;
    margin-right: 1rem;
  }
`

const Text = styled.div`
  line-height: 2;
  margin-top: 1.75rem;
  padding-top: 1rem;
  border-top: 0.125rem solid #9d92c1;
`

type MittuSectionProps = {

}
export const MittuSection: FunctionComponent<MittuSectionProps> = () => {
  return <Outer>
    <Item>
      <ImageContainer>
        <DecoratedFrame leftTop='/images/dec_req_01.png' size="6rem">
          <AutoImage src='/images/req_img_01.png' />
        </DecoratedFrame>
      </ImageContainer>
      <TextContainer>
        <Title>
          <SvgStar />平均年齢26歳!!
        </Title>
        <Text>
          20代の職員が多く、若い職員が活躍できる職場です！<br />
          1年目は、先輩の先生と一緒にクラス運営をしたり、クラス補助に入ったりします。<br />
          1人で仕事をすることがないので、困ったり、迷ったりすることはありません。
        </Text>
      </TextContainer>
    </Item>
    <Item>
      <TextContainer>
        <Title>
          <SvgStar />ハイブリッドな乳幼児施設!!
        </Title>
        <Text>
          認定こども園として、0歳~5歳までの6年間、学童保育として小学生と、さまざまな年齢の子どもたちと関わることができ、保育者として幅広い経験をすることができます。<br />
          平成31年4月に小規模保育所を開所しました。
        </Text>
      </TextContainer>
      <ImageContainer>
        <DecoratedFrame leftBottom='/images/dec_req_02.png' size="6rem">
          <AutoImage src='/images/req_img_02.png' />
        </DecoratedFrame>
      </ImageContainer>
    </Item>
    <Item>
      <ImageContainer>
        <DecoratedFrame rightBottom='/images/dec_req_03.png' size="6rem">
          <AutoImage src='/images/req_img_03.png' />
        </DecoratedFrame>
      </ImageContainer>
      <TextContainer>
        <Title>
          <SvgStar />地方出身者にも優しい!!
        </Title>
        <Text>
          家賃補助制度があります。<br />
          現在、ムロノキッズ職員の3分の1は家賃補助制度を利用しています。<br />
          人数の上限等はありません。
        </Text>
      </TextContainer>
    </Item>

  </Outer>
}